import React, {useEffect, useState} from 'react';
import {SpinnerContainer, Modal, Button, Icon} from '@deviceinsight/ng-ui-basic-components';
import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';
import TriggerRuleConditionsContainer from '../condition/TriggerRuleConditionsContainer';
import {getTriggerDetails, resetCounter} from '../../../api/ruleApi';
import type {UiCondition} from '../../../modules/ruleengine/types';
import '../../../modules/ruleengine/types';
import './TriggerDetails.less';
import {AssetGroup} from '@deviceinsight/ng-ui-api-client';
export type Props = {
	rule: {
		id: string;
		name: string;
	};
	assetGroupId: number;
	onClose: () => void;
};

const TriggerDetails = ({rule: {id, name}, assetGroupId, onClose}: Props) => {
	const [loading, setLoading] = useState<boolean>(false);
	const [conditions, setConditions] = useState<UiCondition | void>(undefined);
	const [lastReset, setLastReset] = useState<number>(new Date().getTime());
	useEffect(() => {
		setLoading(true);
		getTriggerDetails(id, assetGroupId)
			.then(setConditions)
			.finally(() => setLoading(false));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [lastReset]);

	const handleReset = (conditionId: string) => {
		if (conditionId) {
			resetCounter(conditionId, id, assetGroupId).then(initSync);
		}
	};

	const initSync = () => setLastReset(new Date().getTime());

	return (
		<Modal
			className="trigger-details-modal"
			header={
				<div className="trigger-details-header">
					<Trans
						i18nKey="ruleengine.triggerDetails.heading"
						values={{
							ruleName: name
						}}>
						<>
							Trigger Details for &quot;
							{{
								ruleName: name
							}}
							&quot;
						</>
					</Trans>
					<Button naked onClick={initSync}>
						<Icon large sync />
					</Button>
				</div>
			}
			content={
				<SpinnerContainer show={loading}>
					<div className="trigger-details">
						{conditions ? (
							<TriggerRuleConditionsContainer
								conditions={conditions}
								assetGroup={
									{
										id: assetGroupId
									} as AssetGroup
								}
								onReset={handleReset}
							/>
						) : null}
					</div>
				</SpinnerContainer>
			}
			footer={
				<Button onClick={onClose}>
					<Trans i18nKey="ruleengine.triggerDetails.closeButton">Close</Trans>
				</Button>
			}></Modal>
	);
};

export default TriggerDetails;
